/* MEDIA BUYER BUDGET DATA */
export const GET_MEDIA_BUYER_BUDGETS = "GET_MEDIA_BUYER_BUDGETS";
export const SET_MEDIA_BUYER_BUDGETS = "SET_MEDIA_BUYER_BUDGETS";

/* MEDIA BUYER BUDGET ACTIONS */
export const DELETE_MEDIA_BUYER_BUDGET = "DELETE_MEDIA_BUYER_BUDGET";
export const ADD_MEDIA_BUYER_BUDGET = "ADD_MEDIA_BUYER_BUDGET";
export const PATCH_MEDIA_BUYER_BUDGET = "PATCH_MEDIA_BUYER_BUDGET";

/* ONLY DATA FOR ONE  */
export const GET_MEDIA_BUYER_BUDGET_FOR_ID = "GET_MEDIA_BUYER_BUDGET_FOR_ID";
export const SET_MEDIA_BUYER_BUDGET_FOR_ID = "SET_MEDIA_BUYER_BUDGET_FOR_ID";

/* MEDIA BUYER BUDGET GET DATA FOR ADD NEW BUDGET */
export const GET_MEDIA_BUYER_DATA_FOR_ADD = "GET_MEDIA_BUYER_DATA_FOR_ADD";
export const SET_MEDIA_BUYER_DATA_FOR_ADD = "SET_MEDIA_BUYER_DATA_FOR_ADD";

/* FILTERED */
export const GET_FILTERED_MEDIA_BUYER_BUDGET =
  "GET_FILTERED_MEDIA_BUYER_BUDGET";
export const ADD_MEDIA_BUYER_BUDGET_BY_OFFER = "ADD_MEDIA_BUYER_BUDGET_BY_OFFER";
export const DELETE_MEDIA_BUYER_BUDGET_BY_OFFER = "DELETE_MEDIA_BUYER_BUDGET_BY_OFFER";

/* LOADER */
export const SHOW_MEDIA_BUYER_BUDGETS_LOADER =
  "SHOW_MEDIA_BUYER_BUDGETS_LOADER";
export const HIDE_MEDIA_BUYER_BUDGETS_LOADER =
  "HIDE_MEDIA_BUYER_BUDGETS_LOADER";

/* ERRORS */
export const SET_ERROR_MEDIA_BUYER_BUDGETS = "SET_ERROR_MEDIA_BUYER_BUDGETS";
